<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px"
          class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="主动报废编号" prop="sroCode">
                    <el-input v-model="queryCondition.sroCode" clearable placeholder="支持模糊查询"
                      style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="报废项目简介" prop="projectSummary">
                    <el-input v-model="queryCondition.projectSummary" clearable placeholder="支持模糊查询"
                      style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品名称" prop="materialName">
                    <el-input v-model="queryCondition.materialName" clearable placeholder="支持模糊查询"
                      style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态" prop="status">
                    <ic-select clearable table="TT_QUALITY_DEFECT" field="STATUS" placeholder="请选择"
                      v-model="queryCondition.status" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="是否已下发STINV" prop="isIssued">
                      <el-select v-model="queryCondition.isIssued" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item, index) in isIssuedLists" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <!-- <el-input v-model="queryCondition.isIssued" clearable placeholder="支持模糊查询" style="width:100%"></el-input> -->
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow = !isShow">{{ isShow ? '收缩' : '展开' }}<i
                :class="isShow ? 'el-icon-arrow-up iconBtn' : 'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd" v-acl="QUALITY_DEFECT_ADD">新增</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onDel" v-acl="QUALITY_DEFECT_DEL">删除</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QUALITY_DEFECT_EXPORT">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange"
        :checkboxConfig="{ checkMethod: selectable, highlight: true }" @cell-click="cellClick"
        :cell-class-name='setCellClass' max-height="600" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="主动报废编号" resizable min-width="80" field="sroCode">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row)">{{ row.sroCode }}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="主动报废项目简介" resizable min-width="120"
          field="projectSummary"></ux-table-column>
        <ux-table-column align="center" title="报废启动日期" resizable min-width="180" field="startDate"></ux-table-column>
        <ux-table-column align="center" title="等级" resizable min-width="100" field="grade"></ux-table-column>
        <ux-table-column align="center" title="状态" resizable min-width="90" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="是否已下发STINV" resizable min-width="90" field="isIssued"></ux-table-column>
        <ux-table-column align="center" title="下发时间" resizable min-width="90" field="issueDate"></ux-table-column>
        <ux-table-column align="center" title="发起人" resizable min-width="90" field="creator"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize"
          :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false"
      @close="closeDialog">
      <detailDialog v-if="showDetailDialog"></detailDialog>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import StockRecoveryApi from "@/api/StockRecovery/index";
// import detailDialog from './detail.vue'
import paginationMixin from '@/mixins/pagitionMixin';
import { fileService } from "@/api/common/file-utils";
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: 'qualityDefect',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    // detailDialog
  },
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      multipleSelection: [],
      ttQspiStockRecItemIdList: [],
      ttQspiStockRecHeaderIdList: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        sroCode: "",
        projectSummary: "",
        materialName: "",
        status: "",
        isIssued: ""
      },
      isShow: false,
      showDetailDialog: false,
      totalCount: 0,
      pages: 1,
      isIssuedLists: [{
        label: "是",
        value: "Y",
      }, {
        label: "否",
        value: "N",
      }],
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   StockRecoveryApi.qualityDefect(to.meta.reqData).then((res) => {
  //     next(vm => {
  //       vm.queryCondition = to.meta.reqData;
  //       vm.tableData = res.data.records;
  //       vm.totalCount = res.data.total;
  //     })
  //   })
  // },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      StockRecoveryApi.qualityDefect(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    onDetail(row) {
      let ms_userId = localStorage.getItem("ms_userId");
      if ((row.status == 'Draft' || row.status == 'IssueFailed') && row.createBy == ms_userId) {
        this.$router.push({
          path: '/qualityDefect/detail',
          query: {
            ttQualityDefectId: row.ttQualityDefectId,
            from: "edit"
          }
        })
      } else {
        this.$router.push({
          path: '/qualityDefect/view',
          query: {
            ttQualityDefectId: row.ttQualityDefectId,
          }
        })
      }
    },
    onAdd() {
      this.$router.push({
        path: '/qualityDefect/detail',
        query: {
          from: 'add'
        }
      })
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.ttQspiStockRecItemIdList = []
      this.ttQspiStockRecHeaderIdList = []
      val.forEach(ele => {
        this.ttQspiStockRecItemIdList.push(ele.ttQspiStockRecItemId)
        this.ttQspiStockRecHeaderIdList.push(ele.ttQspiStockRecHeaderId)
      })
    },
    onDel() {
      if (this.ttQspiStockRecHeaderIdList.length == 0) {
        this.$my_message('请先选择数据后再操作', 'error');
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'Draft'
      })
      if (!flag) {
        this.$my_message("只有状态为草稿的可以进行删除", 'error');
        return false
      }
      //您确定要删除所选记录吗？
      this.$confirm('您确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        let headerIds = []
        this.multipleSelection.map((v) => {
          headerIds.push(v.ttQualityDefectId)
        })
        StockRecoveryApi.deleteQualityDefect(headerIds).then(res => {
          if (res.code === '200') {
            this.$my_message("删除成功", 'success');
            this.queryData()
          }
        });
      })
    },
    onExport() {
      let newTtQualityDefectIdList = []
      this.multipleSelection.map((v) => {
        newTtQualityDefectIdList.push(v.ttQualityDefectId)
      })
      this.queryCondition.ttQualityDefectIdList = newTtQualityDefectIdList
      StockRecoveryApi.qualityDefectExport(this.queryCondition).then(res => {
        fileService.respToFile(res, '主动报废导出报表.xlsx');
        this.ttQspiStockRecItemIdList = []
        this.$set(this.queryCondition, 'ttQspiStockRecItemIdList', [])
        this.$refs['plxTable'].clearSelection()
      });
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        sroCode: "",
        projectSummary: "",
        materialName: "",
        status: "",
        isIssued: ""
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped ></style>
